// disabling for entire file as window is being used many time in file, also  keeping important logs for better debugging
/* eslint-disable no-undef */
import { useEffect, useRef } from 'react';

const useOrderAlert = () => {
  const audioContextRef = useRef(null);
  const userInteractedRef = useRef(false);

  // Initialize AudioContext on mount
  useEffect(() => {
    if (!audioContextRef?.current) {
      try {
        audioContextRef.current = new (window?.AudioContext ||
          window?.webkitAudioContext)();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('❌ Error creating AudioContext:', error);
      }
    }

    // Request notification permission
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().then((permission) => {});
    }

    // Register Service Worker for mobile
    if ('serviceWorker' in navigator) {
      navigator?.serviceWorker?.register('/service-worker.js').catch(() => {});
    }

    return () => {
      if (
        audioContextRef?.current &&
        audioContextRef?.current?.state !== 'closed'
      ) {
        audioContextRef?.current?.close();
      }
    };
  }, []);

  // Track user interaction
  useEffect(() => {
    const handleInteraction = () => {
      userInteractedRef.current = true;
    };

    ['click', 'touchstart', 'keydown'].forEach((e) =>
      document.addEventListener(e, handleInteraction, { once: true }),
    );
  }, []);

  const playBubblePop = (audioContext) => {
    const playBubble = (startTime, frequency) => {
      const osc = audioContext?.createOscillator();
      const gain = audioContext?.createGain();
      osc?.connect(gain);
      gain?.connect(audioContext?.destination);
      osc.type = 'sine';
      osc?.frequency?.setValueAtTime(frequency, startTime);
      gain?.gain?.setValueAtTime(1, startTime);
      gain?.gain?.exponentialRampToValueAtTime(0.01, startTime + 0.15);
      osc?.start(startTime);
      osc?.stop(startTime + 0.15);
    };
    playBubble(audioContext?.currentTime, 600);
    playBubble(audioContext?.currentTime + 0.15, 800);
    playBubble(audioContext?.currentTime + 0.25, 1000);
    playBubble(audioContext?.currentTime + 0.35, 1200);
  };

  const playNotificationSound = (order) => {
    const orderNumber = order?.orderNumber;

    if (!audioContextRef?.current) {
      return;
    }

    try {
      const audioContext = audioContextRef?.current;
      playBubblePop(audioContext);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error playing sound:', error);
    }

    if ('Notification' in window && Notification.permission === 'granted') {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator?.userAgent);
      const notificationBody = `Order #${orderNumber} requires immediate attention! Order currently is in ${order?.status} status`;
      if (isMobile && 'serviceWorker' in navigator) {
        navigator?.serviceWorker?.ready?.then((registration) => {
          registration?.active?.postMessage({
            type: 'SHOW_NOTIFICATION',
            title: '🚨 Critical Order Alert',
            options: {
              body: notificationBody,
              tag: `critical-order-${orderNumber}`,
              requireInteraction: true,
              silent: false,
            },
          });
        });
      } else {
        const notification = new Notification('🚨 Critical Order Alert', {
          body: notificationBody,
          tag: `critical-order-${orderNumber}`,
          requireInteraction: true,
          silent: false,
          data: {
            orderNumber,
            timestamp: new Date()?.toISOString(),
          },
        });

        notification?.addEventListener('click', () => {
          notification?.close();
          window?.focus();
        });

        setTimeout(() => {
          notification?.close();
        }, 8000);
      }
    }
  };

  return { playNotificationSound };
};

export default useOrderAlert;
